export const ROUTES_NS = 'routes';

export const i18n = {
  en: {
    bunkeringDashboard: 'Bunkering Dashboard',
    bunkeringLogs: 'Bunkering Logs',
    alarmLogs: 'Alarm Logs',
    mfmComparison: 'MFM Comparison',
    settings: 'Settings',
    passwordReset: 'Password Reset',
  },
};
